import { CompanyStatusEnum } from 'constants/company'

export const CommissionPartner = [
  { label: 'No Commission Partner', value: null },
  { label: 'Cason', value: 'Cason' },
]

export const CustomerStatus = [
  { label: 'Draft', value: CompanyStatusEnum.DRAFT },
  { label: 'Active', value: CompanyStatusEnum.ACTIVE },
  { label: 'Inactive', value: CompanyStatusEnum.INACTIVE },
]
